import React from 'react';

const EmailTemplate = ({
  receipientName,
  surveyLink,
  surveyType,
  projectName,
  organizationName,
  templateType,
  role,
  appLink,
  teamName,
  surveyName, // used for client survey
}) => {
  const currentYear = new Date().getFullYear();

  const getEmailBody = () => {
    if (templateType === 'survey') {
      return `
        <p>Hi <strong>${receipientName || 'there'}</strong>,</p>

        <p>We hope your recent experience with <strong>${organizationName}</strong> on <strong>${projectName}</strong> helped drive meaningful outcomes and supported your business priorities. If you have a quick moment, we’d love to know how it went for you.</p>

        <p>Your feedback helps our teams celebrate the wins and fix the gaps, so every interaction gets better.</p>

        <div class="survey-button-container">
          <a href="${surveyLink}" class="survey-button" target="_blank">Share Your Feedback</a>
        </div>

        <p style="margin-top: 30px;">Thank you for trusting us to be part of your journey.</p>

        <p>With gratitude,<br><strong>The ${organizationName} Executive Team</strong></p>

        <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;">

        <p style="font-size: 13px; color: #555; text-align: center;">
          We appreciate your time and partnership.<br>
          <a href="https://www.criticalriver.com" target="_blank" style="color: #004aad; text-decoration: none;">www.criticalriver.com</a> |
          <a href="https://www.linkedin.com/company/criticalriver-inc/" target="_blank" style="color: #004aad; text-decoration: none;">LinkedIn</a> |
          <a href="https://twitter.com/CriticalRiver" target="_blank" style="color: #004aad; text-decoration: none;">Twitter</a>
        </p>
      `;
    } 
    else if (templateType === 'OrgInvitation') {
      return `
        <p>We are excited to invite you to join the <strong>${organizationName} CSAT Application</strong>.</p>
        <p>You’ve been assigned the role of <strong>${role}</strong>.</p>
        <p>Click the button below to get started:</p>
        <a href="${appLink}" class="survey-button">Access CSAT Application</a>
        <p style="margin-top: 30px;">If you have any questions, feel free to reach out.<br> ${organizationName} Team</p>
      `;
    } 
    else if (templateType === 'TeamInvitation') {
      return `
        <p>We are excited to invite you to join the <strong>${organizationName} CSAT Application</strong>.</p>
        <p>You’ve been assigned the role of <strong>${role}</strong> for the team <strong>${teamName}</strong>.</p>
        <p>Click the button below to get started:</p>
        <a href="${appLink}" class="survey-button">Access CSAT Application</a>
        <p style="margin-top: 30px;">If you have any questions, feel free to reach out.<br> ${organizationName} Team</p>
      `;
    } 
    else if (templateType === 'ClientSurvey') {
      return `
        <p>Hi <strong>${receipientName || 'there'}</strong>,</p>

        <p>
          We hope your recent experience with <strong>${organizationName}</strong> 
          has been valuable. We’d love to hear your thoughts through our 
          <strong>${surveyName}</strong>.
        </p>

        <p>
          Your feedback helps us recognize what’s working well and improve where needed,
          so we can continue delivering meaningful outcomes.
        </p>

        <div class="survey-button-container">
          <a href="${surveyLink}" class="survey-button" target="_blank">
            Share Your Feedback
          </a>
        </div>

        <p style="margin-top: 30px;">
          Thank you for your time and continued partnership.
        </p>

        <p>
          With gratitude,<br>
          <strong>The ${organizationName} Executive Team</strong>
        </p>

        <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;">

        <p style="font-size: 13px; color: #555; text-align: center;">
          We appreciate your time and partnership.<br>
          <a href="https://www.criticalriver.com" target="_blank">www.criticalriver.com</a> |
          <a href="https://www.linkedin.com/company/criticalriver-inc/" target="_blank">LinkedIn</a> |
          <a href="https://twitter.com/CriticalRiver" target="_blank">Twitter</a>
        </p>
      `;
    }
    return '';
  };

  const htmlContent = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>${
        templateType === 'survey'
          ? 'Share Your Feedback'
          : templateType === 'ClientSurvey'
          ? 'Client Feedback Survey'
          : 'You Are Invited!'
      }</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #f4f6f8;
          margin: 0;
          padding: 0;
        }
        .survey-button-container {
          text-align: center;
        }
        .email-container {
          max-width: 600px;
          margin: 40px auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        }
        .email-header {
          background-color: #004aad;
          color: #ffffff;
          padding: 10px;
          text-align: center;
        }
        .email-body {
          padding: 30px 20px;
          color: #333333;
        }
        .email-footer {
          font-size: 12px;
          color: #999999;
          text-align: center;
          padding: 20px;
        }
        .survey-button {
          display: inline-block;
          margin-top: 20px;
          padding: 12px 24px;
          background-color: #004aad;
          color: white !important;
          text-decoration: none;
          border-radius: 5px;
          font-weight: bold;
        }
        a {
          color: #004aad;
        }
        @media (max-width: 600px) {
          .email-body {
            padding: 20px 10px;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="email-header">
          <h2>${
            templateType === 'survey'
              ? 'Your Voice Matters to Us'
              : templateType === 'ClientSurvey'
              ? 'Your Voice Matters to Us'
              : 'Invitation to CSAT'
          }</h2>
        </div>
        <div class="email-body">
          ${getEmailBody()}
        </div>
        <div class="email-footer">
          © ${currentYear} ${organizationName}. All rights reserved.
        </div>
      </div>
    </body>
    </html>
  `;

  return htmlContent;
};

export default EmailTemplate;
